import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import PassportEntryPage from './components/PassportEntryPage';
import WorldMapPage from './components/WorldMapPage';
import MissionDetailPage from './components/MissionDetailPage';
import NavigationComponent from './components/NavigationComponent';
import Footer from '../home/components/Footer';
import { usePassport } from '../../hooks/usePassport';

const PassportPage = () => {
	const navigate = useNavigate();
	const [selectedPassport, setSelectedPassport] = useState(null);
	const { passport, existPassword, existPassport } = usePassport(selectedPassport);
	const [pageIndex, setPageIndex] = useState(1);
	const [explore, setExplore] = useState({code: 'IMG', level: passport?.level})

	useEffect(() => {
		if (passport?.level !== undefined) {
			setExplore(prev => ({ ...prev, level: passport.level }));
		}
	}, [passport?.level]);

	return (
		<div className="bg-gradient-to-br from-blue-900 to-blue-500 min-h-screen">
			<nav className="bg-white shadow-sm sticky top-0 z-50">
				<div className="max-w-7xl mx-auto px-4 py-4">
					<div className="flex items-center justify-between">
						<button onClick={() => navigate('/')} className="flex items-center space-x-2 text-gray-700 hover:text-purple-600 transition-colors cursor-pointer">
							<i className="ri-arrow-left-line text-xl"></i>
							<span className="font-bold text-xl">AIKnow 라이브 클래스</span>
						</button>
					</div>
				</div>
			</nav>
			<section id="passportEntry" className="min-h-[80vh] py-12">
				<div className="max-w-[900px] mx-auto shadow-none md:shadow-[0_20px_60px_rgba(0,0,0,0.3)] overflow-hidden text-center relative rounded-none md:rounded-[20px]">
					{pageIndex === 1 && <PassportEntryPage setPageIndex={setPageIndex} setSelectedPassport={setSelectedPassport}/>}
					{existPassport && existPassword && pageIndex === 2 && <WorldMapPage setPageIndex={setPageIndex} passport={passport} explore={explore} setExplore={setExplore}/>}
					{existPassport && existPassword && pageIndex === 3 && <MissionDetailPage explore={explore}/>}
					{existPassport && existPassword && <NavigationComponent pageIndex={pageIndex} setPageIndex={setPageIndex} explore={explore} setExplore={setExplore}/>}
				</div>
			</section>
			<Footer />
		</div>
	);
}

export default PassportPage;